import { render } from "./HelpTopic.vue?vue&type=template&id=55983498&scoped=true"
import script from "./HelpTopic.vue?vue&type=script&lang=js"
export * from "./HelpTopic.vue?vue&type=script&lang=js"

import "./HelpTopic.vue?vue&type=style&index=0&id=55983498&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55983498"]])

export default __exports__